import React, { useEffect, useState } from "react";
import pdf from "../assests/data/Premisin_resource.pdf";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import HubspotForm from "react-hubspot-form";

const Workspace = () => {
  const navigate = useNavigate();
  const [details, setDetails] = useState({
    email: "",
    mobile: "",
    name: "",
    check: "",
  });

  const [cap1, setCap1] = useState("");
  const [cap2, setCap2] = useState("");
  const [mess, setMess] = useState("");

  useEffect(() => {
    const otp = Math.floor(1 + Math.random() * 9);
    const otp2 = Math.floor(1 + Math.random() * 9);
    setCap1(otp);
    setCap2(otp2);
  }, []);

  const total = cap1 + cap2;

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFormSUbmit = async (e) => {
    e.preventDefault();
    if (details.check == total) {
      setMess("processing...");
      await axios
        .post("https://landing.premisin.com/reactSubmit.php", {
          name: details.name,
          email: details.email,
          mobile: details.mobile,
          action: "side_resource",
        })
        .then((response) => {
          setMess(response.data.message);
          if (response.data.status === 1) {
            setDetails({ name: "", email: "", mobile: "" });
            navigate("/thankyou");
            setMess(response.data.message);
            window.gtag("event", "conversion", {
              send_to: "AW-10896336864/HC9qCKTrsLoDEODP48so",
              // event_callback: callback,
            });
            const link = document.createElement("a");
            link.href = pdf;
            link.download = "Premisin resource.pdf";
            link.click();
          }
        })
        .catch((error) => {
          console.log(error);
          setMess("Something went wrong");
        });
    } else {
      setMess("Please Enter Correct Addition.");
    }
  };
  return (
    <>
      <section id="workspace" className="startup-team">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-12 mx-auto">
              <h2 className="h1" style={{ color: "#fff" }}>
                Ready to Elevate Your Workspace?
              </h2>
              <div className="u-h-4 u-w-50 bg-white rounded mt-4 u-mb-30 mx-auto"></div>
              <p style={{ color: "#fff" }}>
                Check out the Office space resource that helps you to find
                perfect office space in raipur
              </p>

              <div className="text-center mx-auto mb-4">
                <a
                  data-toggle="modal"
                  data-target="#sidenavmail12"
                  onClick={() => window.gtag('event', 'button_click_resource')}
                  className="btn btn btn-rounded btn-primary mt-5"
                  style={{ backgroundColor: "#fff", color: "#0081FF" }}
                >
                  <i className="fa fa-download mr-1" aria-hidden="true"></i>
                  Resource
                </a>
                {/* <a  href={pdf} data-toggle="modal" data-target="#downloadResource" style={{backgroundColor : "#fff" , color :"#0081FF"}}  onclick="gtag('event','button_click_resource');" className="btn btn btn-rounded btn-primary mt-5" download><i className="fa fa-download mr-1" aria-hidden="true"  ></i>Resource</a> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className="modal fade"
        id="sidenavmail12"
        data-backdrop="static"
        data-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Get Your Office Quote Now!</h3>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="p-3 u-of-hidden">
                <div style={{ marginBottom: '-105px' }}>
                  <HubspotForm
                    portalId='7848680'
                    formId='5f122df2-e3ea-42b4-b86f-628bdf7cfed3'
                    onSubmit={() => console.log('Submit!')}
                    onReady={(form) => console.log('Form ready!')}
                    loading={<div>Loading...</div>}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Workspace;
